<template>
  <section class="statv_wrapper">
    <h2 class="disabled"> 일일 편성표 </h2>
    <div class="schedule_wrap">
      <article class="date_selector">
        <div class="date_title" @click.prevent="setDate(currentDate)"> {{ formDate(currentDate, 'YYYY/MM/DD') }} </div>
        <i class="calender_icon" @click.prevent="openCal"
          v-closable-div="{ owner: 'datapicker_container', call: 'closeCal' }"></i>
        <div class="datapicker_container" ref="datapicker_container">
          <Datepicker v-model="searchDate" ref="datepicker" :format="dateFormat" wrapper-class="datepicker_wrapper"
            input-class="datepicker_input" calendar-class="datepicker_calendar" :full-month-name="true">
          </Datepicker>
        </div>
      </article>

      <article class="schedule_header">
        <div :class="['date_item paint', { 'active': isSame(day, searchDate) }, { 'today': isSame(day, today) }]"
          v-for="(day, idx) in list" :key="`day_${idx}`">
          <div @click.prevent="searchDate = formDate(day, 'YYYY-MM-DD')"> {{ formDate(day, 'M/D') }} </div>
        </div>
        <div class="btn date_prev" @click.prevent="next(-1)"> </div>
        <div class="btn date_next" @click.prevent="next(1)"> </div>
      </article>
      <div class="date_under_line"></div>

      <article class="schedule_body">
        <h3 class="disabled"> 편성내용 </h3>
        <div class="schedule_no_data" v-if="schedules.length == 0">
          <p> 방송 내용이 확정되지 않았습니다. </p>
        </div>
        <div :class="['schedule_item', { 'now': schedule.now }]" v-for="(schedule, idx) in schedules"
          :key="`schedule_${idx}`">
          <div class="column1 cell"> {{ schedule.time }} </div>
          <div class="column2 cell badge" :class="rowClassName(schedule.type)"></div>
          <div class="column3 cell badge" :class="`age_${schedule.age}`"> </div>
          <div class="column4 cell"> {{ schedule.content }} </div>
        </div>
        <div v-if="schedules.legnth == 0"> asdsadad </div>
      </article>

      <article class="schedule_footer">
        <div class="schedule_info"> *편성표는 방송사 사정에 따라 변경될 수 있습니다. </div>
        <div class="type_info">
          <div class="badge live"></div> <span> 생방송 </span>
          <div class="badge air"></div> <span> 본방송 </span>
          <div class="badge replay"></div> <span> 재방송 </span>
        </div>
        <div class="type_info">
          <div class="badge age_12"></div> <span> 12세 이상 </span>
          <div class="badge age_15"></div> <span> 15세 이상 </span>
          <div class="badge age_19"></div> <span> 19세 이상 </span>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import * as Store from "@/store/modules/schedule"
import Datepicker from "vuejs-datepicker"
import Utils from "@/helpers/utils.js";

export default {
  components: { Datepicker },
  data() {
    return {
      dateFormat: "yyyy/MM/dd",
      currentDate: null,
      searchDate: null,
      today: null,
      list: [],
    }
  },
  created() {
    this.today = moment()
  },
  mounted() {
    this.currentDate = moment()
    this.searchDate = moment().format("YYYY-MM-DD")
  },
  computed: {
    ...Store.mapState([
      'schedules'
    ]),
  },
  watch: {
    async searchDate(n) {
      await this.getSchedules(n)
      this.currentDate = moment(n)
      this.setDate(this.currentDate)
    },
  },
  methods: {
    ...Store.mapActions([
      'getSchedules'
    ]),
    isOpenCal() {
      return this.$refs.datepicker.isOpen
    },
    openCal() {
      if (!this.$refs.datepicker.isOpen) this.$refs.datepicker.showCalendar()
      else this.closeCal()
    },
    closeCal() {
      if (this.$refs.datepicker.isOpen) this.$refs.datepicker.close()
    },
    next(num) {
      let cnt = Utils.isMobile() ? 5 : 7
      let temp = []
      _.forEach(this.list, v => {
        temp.push(v.clone().add(num * cnt, 'days'))
      })

      this.list = temp
    },
    isSame(value, compare) {
      return moment(value, "YYYYMMDD").isSame(moment(compare, "YYYYMMDD"), 'day')
    },
    rowClassName(type) {
      let list = { "재방송": "replay", "생방송": "live", "본방송": "air" }
      return _.has(list, type) ? list[type] : ""
    },
    formDate(date, format) {
      return moment.isMoment(date) ? date.format(format) : moment(date).format(format)
    },
    setDate(date) {
      if (_.size(this.list.filter(v => v.isSame(date, 'days'))) > 0) return
      this.list = []
      let prev = [], next = []
      let size = Utils.isMobile() ? 2 : 3
      for (var i = 1; i <= size; i++) {
        prev.push(date.clone().add(-i, 'days'))
        next.push(date.clone().add(i, 'days'))
      }
      _.reverse(prev).push(date.clone())
      this.list = prev.concat(next)
    },
  }
}
</script>
<style lang="less">
.schedule_wrap {
  background-color: #FFFFFF;

  .date_selector {
    position: relative;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 170px;

    .date_title {
      font-size: 60px;
      font-family: "BebasNeue";
      color: #ff6400;
      letter-spacing: 0;
      padding: 0 12px;
      cursor: pointer;
    }

    .calender_icon {
      display: block;
      width: 21px;
      height: 24px;
      cursor: pointer;
      background-image: url("~@/assets/image/schedule/calendar_btn.png");
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  .schedule_header {
    position: relative;
    display: flex;
    // width: 100%;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    // border-bottom: 2px solid #ff6400;
    padding: 0 50px;

    .date_item {
      order: 2;
      // flex: 1 0 0;
      position: relative;
      text-align: center;
      font-family: "BebasNeue";
      font-size: 34px;
      color: #ff6400;

      >div {
        cursor: pointer;
      }

      &.active {
        font-family: "BebasNeue";
      }

      &.active.today {
        &::after {
          // bottom: 84px;
        }
      }

      &.today {
        &::after {
          content: "";
          background-image: url("~@/assets/image/schedule/today_img.png");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% 100%;
          position: absolute;
          width: 39px;
          height: 30px;
          bottom: 0px;
          top: 0;
          left: 0;
          right: 0;
          margin: auto;
          display: block;
          margin-bottom: 45px;
        }
      }
    }

    .btn {
      position: absolute;
      width: 15px;
      height: 16px;
      cursor: pointer;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;

      // flex: 1 1 0;
      &.date_prev {
        left: 23px;
        background-image: url("~@/assets/image/schedule/arrow_left@2x.png");
      }

      &.date_next {
        right: 23px;
        background-image: url("~@/assets/image/schedule/arrow_right.png");
      }
    }
  }

  .date_under_line {
    position: relative;
    border-bottom: 2px solid #ff6400;
    z-index: 1;
  }

  .schedule_body {
    min-height: 450px;

    .schedule_no_data {
      width: 100%;
      height: 450px;
      // min-height: 450px;
      display: flex;
      // flex-flow: column wrap;
      justify-content: center;
      align-items: center;
      font-size: 17px;
      color: #8F8F8F;
      font-weight: 400;
      border-bottom: 1px solid rgba(143, 143, 143, 0.3);

      p {}
    }

    .schedule_item {
      display: flex;
      flex-flow: row wrap;
      border-bottom: 1px solid rgba(143, 143, 143, 0.3);
      align-items: center;
      height: 50px;
      color: #8F8F8F;
      margin: 0 15px;

      &.now {
        color: #ff6400;
        background-color: #fff3ce;
      }

      .cell {
        display: flex;
        justify-content: center;

        &.column1 {
          flex: 1.5 1 0;
          order: 1;
          font-family: "BebasNeue";
          // justify-content: flex-end;
          font-size: 20px;
        }

        &.column2 {
          flex: 0.5 1 0;
          order: 2;

          &.air {
            background-image: url("~@/assets/image/schedule/original-air_img.png");
          }

          &.replay {
            background-image: url("~@/assets/image/schedule/re-air_img.png");
          }

          &.live {
            background-image: url("~@/assets/image/schedule/live_img.png");
          }
        }

        &.column3 {
          flex: 1.5 1 0;
          order: 3;

          &.age_ {
            background-image: url("~@/assets/image/schedule/all_img@2x.png");
          }

          &.age_12 {
            background-image: url("~@/assets/image/schedule/12_img.png");
          }

          &.age_15 {
            background-image: url("~@/assets/image/schedule/15_img.png");
          }

          &.age_19 {
            background-image: url("~@/assets/image/schedule/19_img.png");
          }
        }

        &.column4 {
          flex: 10 1 0;
          order: 4;
          font-size: 17px;
          font-weight: 600;
          justify-content: flex-start;
          transform: skew(-0.05deg);
        }
      }
    }
  }

  .schedule_footer {
    padding-left: 63px;
    margin-top: 20px;

    .schedule_info {
      font-size: 16px;
      font-weight: 400;
      color: #8F8F8F;
      padding-bottom: 30px;
    }

    :nth-child(2).type_info {
      padding-bottom: 16px;
    }

    .type_info {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      color: #8F8F8F;
      font-size: 16px;

      .air {
        background-image: url("~@/assets/image/schedule/original-air_img.png");
      }

      .replay {
        background-image: url("~@/assets/image/schedule/re-air_img.png");
      }

      .live {
        background-image: url("~@/assets/image/schedule/live_img.png");
      }

      .age_ {
        background-image: url("~@/assets/image/schedule/all_img@2x.png");
      }

      .age_12 {
        background-image: url("~@/assets/image/schedule/12_img.png");
      }

      .age_15 {
        background-image: url("~@/assets/image/schedule/15_img.png");
      }

      .age_19 {
        background-image: url("~@/assets/image/schedule/19_img.png");
      }

      >span {
        width: 70px;
        padding: 0 5px;
        margin-right: 22px;
        font-weight: 400;
        transform: skew(-0.05deg);
      }
    }
  }
}

.m .schedule_wrap {
  padding-bottom: 160px;

  .date_selector {
    height: 235px;

    .date_title {
      font-size: 78px;
      padding-right: 15px;
    }

    .calender_icon {
      display: block;
      width: 35px;
      height: 40px;
      cursor: pointer;
      background-image: url("~@/assets/image/schedule/calendar_btn.png");
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  .schedule_header {
    // border-bottom: 2px solid #ff6400;
    height: 48px;
    padding: 0 60px;

    .date_item {
      font-size: 40px;

      &.active {
        font-size: 42px;
      }

      &.today {
        &::after {
          background-image: url("~@/assets/image/schedule/today_img.png");
          margin-bottom: 58px;
          width: 44px;
          height: 35px;
        }
      }
    }
  }

  .schedule_body {
    padding: 0;
    min-height: 600px;

    .schedule_no_data {
      height: 600px;
      font-size: 24px;
      color: #717171;
    }

    .schedule_item {
      height: 80px;
      margin: 0;

      .cell {
        &.column1 {
          font-size: 30px;
        }

        &.column2 {
          flex: 0.5 1 0;
          order: 2;
        }

        &.column3 {
          flex: 1 1 0;
          order: 3;
        }

        &.column4 {
          flex: 9 1 0;
          font-size: 24px;
        }
      }
    }
  }

  .schedule_footer {
    padding: 0;
    margin-top: 26px;
    text-align: center;

    .schedule_info {
      font-size: 22px;
      padding-bottom: 61px;
    }

    .type_info {
      font-size: 20px;

      >span {
        width: 100px;
        text-align: left;
      }
    }
  }
}
</style>